const CONFIG = {
  CRS_CONSUMER_CONSENT_SERVICE:
    'https://crs-consumer-portal.dev.aws.jpmchase.net',
};

export default CONFIG;
